import { render } from "./PackagesPage.vue?vue&type=template&id=1d7f5b70&scoped=true"
import script from "./PackagesPage.vue?vue&type=script&lang=js"
export * from "./PackagesPage.vue?vue&type=script&lang=js"

import "./PackagesPage.vue?vue&type=style&index=0&id=1d7f5b70&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d7f5b70"]])

export default __exports__